// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__V1LLF","summary":"CartItem_summary__Ov-Ql","price":"CartItem_price__EWWpG","amount":"CartItem_amount__fxzhN","actions":"CartItem_actions__Sr3JE"};